/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OtherFile/view.blocks to change it.
import OpenInNewTabAction from './OpenInNewTabAction/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function OtherFile({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/OtherFile"
  
}) {
  let isMedia = useIsMedia()
  return (<React.Fragment
>
<div
  data-testid="OtherFile.Vertical"
  data-view-path={viewPath}
 style={{'--ai-1-4a50F': isMedia.mobile ? "flex-start" : "center",'--jc-2-4a50F': isMedia.mobile ? "flex-start" : "center"}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 text="No preview available for the selected file"
/>
</div>
<OpenInNewTabAction
  viewPath={`${viewPath}/OpenInNewTabAction`}
/>
{children}
</React.Fragment>)
}